<div class="header">
    <nav class="navbar navbar-toggleable-md navbar-light bg-faded">
        <div class="container w-100">
            <button class="navbar-toggler navbar-toggler-right" type="button"
                    (click)="isNavbarCollapsed = !isNavbarCollapsed"
                    aria-controls="exCollapsingNavbar2" aria-expanded="false" aria-label="Toggle navigation">
                <span class="icon-bar"></span> <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand p-h-l-xmd cursor" (click)="hubClicked()">
                <img *ngIf="tenantImage" [src]="tenantImage" style="height:40px">
                <div *ngIf="!tenantImage" class="logo"></div>
            </a>
            <div style="flex-grow: 1;"></div>
            <div [ngbCollapse]="!isNavbarCollapsed" class="collapse navbar-collapse" id="exCollapsingNavbar2">
                <div class="navbar-nav pull-right">


                    <a class="nav-item nav-link pull-left cursor p-0 d-flex align-items-center" (click)="hubClicked()">
                        <i class="fonticon-home m-2"></i>
                    </a>

                    <a class="nav-item nav-link pull-left cursor p-0">
                        <i class="fa fa-user-circle-o m-2"></i>
                        <span class="hide-txt">{{ displayName }} </span>
                    </a>

                    <li class="nav-item nav-link pull-left cursor p-0 d-flex align-items-center">
                        <div ngbDropdown class="d-inline-block" placement="bottom-right">
                            <!--              <i class="fa fa-globe" style="font-size:30px;" id="dropdownBasic1" ngbDropdownToggle></i>-->
                            <i class="fonticon-language m-2" id="dropdownBasic1" ngbDropdownToggle></i>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                <a *ngFor="let lang of allLanguage"
                                   class="dropdown-item b py-2 px-4 text-nowrap c-p d-flex justify-content-between m-0"
                                   (click)="selectLanguage(lang)">{{ lang.name }}
                                </a>
                            </div>
                        </div>
                    </li>

                    <a class="nav-item nav-link pull-left cursor p-0" (click)="logout()" routerLinkActive="active">
                        <i class="fa fa-power-off m-2"></i>
                        <span class="hide-txt">{{ "logout" | translate }} </span>
                    </a>


                </div>
            </div>
        </div>
    </nav>
</div>


// WEBPACK FOOTER //
// ./src/app/header/header.html